// Set to true to use SECONDS instead of MINUTES for testing
export const TEST_MODE = false;

export const DEBUG_MODE = false;

export const LOG = false;

export const log = (context: string, message: string, data?: unknown): void => {
  if (!LOG) return;
  const timestamp = new Date().toISOString().split('T')[1].slice(0, 12);
  console.log(`[${context} ${timestamp}] ${message}`, data !== undefined ? data : '');
};

export const TIME_UNIT = TEST_MODE ? 1000 : 60 * 1000; // 1 second or 1 minute

export const INACTIVITY_LOGOUT_TIME = 60 * TIME_UNIT; // minutes/seconds
export const ACTIVITY_CHECK_INTERVAL = 1000; // Check every 1 second
export const WARNING_THRESHOLD = 30; // Show warning at this remaining time

export const TOKEN_REFRESH_BUFFER = 5 * 1000; // Refresh before expiry
export const TOKEN_CHECK_INTERVAL = 1 * 1000; // Check token every

export const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];

export interface TokenInfo {
  accessExp: number | null;
  idExp: number | null;
}

export interface RefreshEvent {
  time: number;
  oldExp: number;
  newExp: number;
}

export interface SessionState {
  isAuthenticated: boolean;
  isLoading: boolean;
  tokenInfo: TokenInfo;
  lastActivity: number;
  refreshCount: number;
  lastRefresh: RefreshEvent | null;
  refreshLog: RefreshEvent[];
  error: string | null;
}
